export default __webpack_public_path__ + "static/light-house-dfefb0a5714bda86a3057ca1f5e5bfd3.jpg";